import { render, staticRenderFns } from "./ReferralRecordList.vue?vue&type=template&id=6be28017&scoped=true"
import script from "./ReferralRecordList.vue?vue&type=script&lang=js"
export * from "./ReferralRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be28017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be28017')) {
      api.createRecord('6be28017', component.options)
    } else {
      api.reload('6be28017', component.options)
    }
    module.hot.accept("./ReferralRecordList.vue?vue&type=template&id=6be28017&scoped=true", function () {
      api.rerender('6be28017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/seekBeauty/ReferralRecordList.vue"
export default component.exports